import { c as _c } from "react/compiler-runtime";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import ParticipationDropVoteDetailsTrigger from "@/components/waves/drops/participation/ratings/ParticipationDropVoteDetailsTrigger";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import Link from "next/link";
import React from "react";
import { Tooltip } from "react-tooltip";
interface MemesLeaderboardDropVoteSummaryProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropVoteSummary: React.FC<MemesLeaderboardDropVoteSummaryProps> = t0 => {
  const $ = _c(42);
  const {
    drop
  } = t0;
  const current = drop.rating;
  const projected = drop.rating_prediction;
  const creditType = drop.wave.voting_credit_type;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== creditType || $[1] !== current || $[2] !== drop.context_profile_context || $[3] !== drop.top_raters || $[4] !== projected) {
    const topVoters = drop.top_raters.slice(0, 3);
    const userContext = drop.context_profile_context;
    const isPositive = current >= 0;
    const hasUserVoted = userContext?.rating !== undefined && userContext?.rating !== 0;
    const userVote = userContext?.rating ?? 0;
    const isUserVoteNegative = userVote < 0;
    t4 = "tw-flex @[700px]:tw-flex-1 tw-items-center tw-gap-4 @[700px]:tw-justify-between";
    const t6 = `tw-font-bold tw-font-mono tw-tracking-tight tw-text-sm ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
    let t7;
    if ($[10] !== current) {
      t7 = formatNumberWithCommas(current);
      $[10] = current;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t6 || $[13] !== t7) {
      t8 = <span className={t6}>{t7}</span>;
      $[12] = t6;
      $[13] = t7;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== current || $[16] !== projected) {
      t9 = <DropVoteProgressing current={current} projected={projected} />;
      $[15] = current;
      $[16] = projected;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== creditType) {
      t10 = <span className="tw-text-iron-500 tw-text-sm tw-ml-1">{creditType} total</span>;
      $[18] = creditType;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== hasUserVoted || $[21] !== isUserVoteNegative || $[22] !== userVote) {
      t11 = hasUserVoted && <span className="tw-hidden @[500px]:tw-inline tw-text-xs tw-text-iron-500 tw-font-mono tw-ml-3 tw-border-l tw-border-solid tw-border-white/10 tw-pl-3 tw-border-t-0 tw-border-r-0 tw-border-b-0">Your vote:{" "}<span className="tw-text-white tw-font-bold">{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}</span></span>;
      $[20] = hasUserVoted;
      $[21] = isUserVoteNegative;
      $[22] = userVote;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    if ($[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
      t5 = <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm">{t8}{t9}{t10}{t11}</div>;
      $[24] = t10;
      $[25] = t11;
      $[26] = t8;
      $[27] = t9;
      $[28] = t5;
    } else {
      t5 = $[28];
    }
    t3 = "tw-hidden @[700px]:tw-flex tw-items-center tw-gap-2";
    t1 = "tw-flex tw-items-center -tw-space-x-2";
    t2 = topVoters.map(_temp2);
    $[0] = creditType;
    $[1] = current;
    $[2] = drop.context_profile_context;
    $[3] = drop.top_raters;
    $[4] = projected;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[29] !== t1 || $[30] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== drop) {
    t7 = <ParticipationDropVoteDetailsTrigger drop={drop} />;
    $[32] = drop;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t3 || $[35] !== t6 || $[36] !== t7) {
    t8 = <div className={t3}>{t6}{t7}</div>;
    $[34] = t3;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t4 || $[39] !== t5 || $[40] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[38] = t4;
    $[39] = t5;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};
export default MemesLeaderboardDropVoteSummary;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp} data-tooltip-id={`voter-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}